import retext from 'retext';
import keywords from 'retext-keywords';
import pos from 'retext-pos';
import english from 'retext-english';
import toString from 'nlcst-to-string';


export const KeyWordParser = {

    parseKeywords: (text:string, stopWords:string[] = [], max:number = 5) => {

        const removeText = [ "re", "t", "s", "ve", "ll", "you", "they", "we", "he", "she", "i'm", "isn", "won", "AMP", "ASV", "DBY", "ERV", "ESV", "KJV", "MSG", "OJB", "NASB", "NIRV", "NIV", "NLT", "WEB", "YLT", "LBLA", "NBL", "NKJV"].concat(stopWords);
        const removeContractionsRegex = new RegExp("([A-Za-z]+'[A-Za-z]+)", "gi");
        const stopStr = removeText.join("|");
        
        let search = text.replace(/<(?:.|\n)*?>/gm, ' ')
            .replace(removeContractionsRegex, ' ')
            .replace(new RegExp('\\b(' + stopStr + ')\\b', 'gi'), ' ')
            .replace(/\s{2,}/g, ' ')
            .replace(/&nbsp/gm, ' ')
            .replace(/[^A-Za-z0-9\s]/g," ")
        
        let foundKeywords:string[] = []
        retext()
            .use(english)
            .use(pos)
            .use(keywords, {maximum: max})
            .process(search, (err:Error, file:any) => {
            if (err) throw err
            file.data.keywords.forEach((keyword:any) => {
              foundKeywords.push(toString(keyword.matches[0].node))
            })
        })

        return foundKeywords;
    },
}

export default KeyWordParser;